<template>
  <div ref="videoWrapper" class="video-wrapper" :class="{ 'video-wrapper-horizontal': screenType === 1 }">
    <div id="local_video" class="zb-video" style="object-fit: cover;"></div>
	<playSvga ref="svga" v-if="show_svga"/>
	<!-- 手机竖屏直播：bgUrl 背景图覆盖在视频画面上层 -->
	<div class="portrait-cover-overlay" v-if="backgroundUrl && screenType !== 1" :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"></div>
  </div>
</template>

<script>
import { getChatRoomDetails,sendRefreshMsg } from "@/api/zhibo";
import playSvga from "../playSvga/playSvga.vue";
export default {
  components: {
    playSvga
  },
  data() {
    return {
	  livePusher:null,
	  audioEffectManager:null,
	  videoEffectManager:null,
	  cameraStreamId:null,
	  data:'',
	  show_svga:true,
	  isDeviceReady: false, // 标记媒体设备是否就绪
	  isPushing: false, // 标记是否正在推流
	  isMirrored: false, // 标记镜像状态
	  screenType: 0, // 屏幕类型（0=竖屏，1=横屏）
	  verticalAspectRatio: 9 / 17, // 竖屏（稍窄一些）
	  horizontalAspectRatio: 16 / 12, // 横屏
	  currentAspectRatio: 9 / 17, // 当前使用的宽高比
	  backgroundUrl: '', // 手机竖屏直播背景图
    };
  },
  mounted() {
	this.calculatePlayerSize();
	window.addEventListener("resize", this.calculatePlayerSize);
	this.getLivePusher()
  },
  methods: {
	calculatePlayerSize() {
		const container = this.$refs.videoWrapper;
		if (!container) return;

		const parentContainer = container.parentElement;
		if (!parentContainer) return;
		const parentWidth = parentContainer.offsetWidth;
		const viewportHeight = window.innerHeight;
		const maxAvailableHeight = viewportHeight - 126;

		let maxPlayerWidth;
		if (this.screenType === 1) {
			maxPlayerWidth = parentWidth * 0.5;
		} else {
			maxPlayerWidth = parentWidth;
		}

		const calculatedWidth = maxAvailableHeight * this.currentAspectRatio;

		let finalWidth, finalHeight;

		if (calculatedWidth > maxPlayerWidth) {
			finalWidth = maxPlayerWidth;
			finalHeight = finalWidth / this.currentAspectRatio;
		} else {
			finalHeight = maxAvailableHeight;
			finalWidth = calculatedWidth;
		}

		if (finalHeight > maxAvailableHeight) {
			finalHeight = maxAvailableHeight;
			finalWidth = finalHeight * this.currentAspectRatio;
		}

		container.style.width = `${finalWidth}px`;
		container.style.height = `${finalHeight}px`;
	},
	async getLivePusher(data){
		const quality = data?data:'720p'
		this.livePusher = new TXLivePusher();
		this.audioEffectManager  = this.livePusher.getAudioEffectManager()
		this.videoEffectManager = this.livePusher.getVideoEffectManager()
		// 开启本地混流功能（镜像等视频效果依赖此功能）
		this.videoEffectManager.enableMixing(true)
		this.livePusher.setRenderView('local_video');
		this.livePusher.videoView.muted = true;
		// 设置视频质量
		this.livePusher.setVideoQuality(quality);
		// 设置音频质量
		this.livePusher.setAudioQuality('standard');
		// 自定义设置帧率
		this.livePusher.setProperty('setVideoFPS', 25);
		
		// 添加事件监听
		this.livePusher.setObserver({
			onPushStatusUpdate: (code, message) => {
				console.log('推流状态更新:', code, message);
				if (code === 1001) { // 正在连接
					this.isPushing = false;
				} else if (code === 1002) { // 连接成功
					this.isPushing = true;
					console.log('推流真正成功了');
				} else if (code === -1307) { // 连接断开
					this.isPushing = false;
					console.error('推流连接断开');
				}
				if(code == 2){
					this.sendRefreshMsg()
				}
			},
			onPushError: (code, message) => {
				console.error('推流错误:', code, message);
				this.isPushing = false;
			}
		});

		try {
			// 打开摄像头和麦克风，确保获取流成功后再继续
			console.log('正在启动摄像头和麦克风...');
			this.cameraStreamId = await this.livePusher.startCamera();
			await this.livePusher.startMicrophone();
			this.isDeviceReady = true;
			console.log('摄像头和麦克风启动成功, streamId:', this.cameraStreamId);

			// 等待第一帧视频帧产生后再推流，避免推空流导致观众端黑屏
			await this.waitForFirstFrame();

			// 设备启动成功且第一帧已产生后再获取详情并开始推流
			await this.getChatRoomDetails()
		} catch (error) {
			console.error('媒体设备启动失败:', error);
			this.isDeviceReady = false;
		}
	},
	// 等待摄像头第一帧产生，确保推流时有视频数据
	waitForFirstFrame() {
		return new Promise((resolve) => {
			const videoEl = this.livePusher && this.livePusher.videoView;
			// 没有 videoView 或不是 video 元素，直接继续
			if (!videoEl || videoEl.tagName !== 'VIDEO') {
				console.warn('videoView 不可用，跳过等待第一帧');
				resolve();
				return;
			}
			// readyState >= 2 (HAVE_CURRENT_DATA) 说明已有帧数据
			if (videoEl.readyState >= 2) {
				console.log('视频帧已就绪，可以推流');
				resolve();
				return;
			}
			console.log('等待第一帧视频帧产生...');
			const onReady = () => {
				console.log('第一帧视频帧已产生，开始推流');
				videoEl.removeEventListener('loadeddata', onReady);
				videoEl.removeEventListener('playing', onReady);
				clearTimeout(timer);
				resolve();
			};
			videoEl.addEventListener('loadeddata', onReady);
			videoEl.addEventListener('playing', onReady);
			// 超时兜底：3秒后强制继续，避免一直卡住
			const timer = setTimeout(() => {
				console.warn('等待第一帧超时(3s)，强制继续推流');
				videoEl.removeEventListener('loadeddata', onReady);
				videoEl.removeEventListener('playing', onReady);
				resolve();
			}, 3000);
		});
	},
	//推流成功刷新接口
	async sendRefreshMsg(){
		const res = await sendRefreshMsg({liveId:this.$route.query.liveId})
	},
	//开始推流
	async startPush(){
		if (!this.isDeviceReady) {
			console.warn('设备未就绪，推流取消');
			return;
		}
		const pushUrl = this.data.chatRoomDetails.pushUrl
		const newUrl = pushUrl.replace(/^rtmp:\/\//, 'webrtc://');
		
		try {
			console.log('正在尝试推流:', newUrl);
			await this.livePusher.startPush(newUrl);
			console.log('startPush 调用成功，等待状态更新...');
		} catch (error) {
			console.error('推流发起失败:', error);
			this.isPushing = false;
		}
	},
	//设置画质
	async setVideoQuality(data){
		if (this.livePusher) {
			this.livePusher.stopPush();
			this.livePusher.stopCamera();
			this.livePusher.stopMicrophone();
			this.livePusher.destroy()
			this.livePusher = null
		}
		this.isDeviceReady = false;
		this.isPushing = false;
		const quality = data===0?'720p':data===1?'360p':'1080p'
		await this.getLivePusher(quality)
	},
	//直播间详情
	async getChatRoomDetails(){
		if(!this.$route.query.liveId){
		  return
		}
		const res = await getChatRoomDetails({liveId:this.$route.query.liveId})
	this.data = res.data
	this.backgroundUrl = res.data.chatRoomDetails.bgUrl
	this.screenType = res.data.chatRoomDetails.screenType || 0
	this.currentAspectRatio = this.screenType === 1
		? this.horizontalAspectRatio
		: this.verticalAspectRatio
	this.calculatePlayerSize()
	console.log('获取推流链接, screenType:', this.screenType)
		setTimeout(v=>{
			this.startPush()
		},5000)
	},
	//设置音量（同时控制混音音量和推流音频轨道静音）
	setVolume(data){
		console.log(data)
		this.audioEffectManager.setVolume(data)
		// 音量为 0 时同时关闭推流的音频轨道，让观众听不到；>0 时恢复
		if (this.livePusher) {
			this.livePusher.setAudioMute(data == 0)
		}
	},
	//播放礼物
	addGiftToQueue(data){
		console.log(data,123)
		this.$refs.svga.addGiftToQueue(data)
	},
	//显示或者关闭特效
	showSvga(data){
		this.show_svga = data
	},
	//切换摄像头
	async toggleCamera(enable) {
		if (!this.livePusher) return;
		try {
			if (enable) {
				this.livePusher.setVideoMute(false);
			} else {
				this.livePusher.setVideoMute(true);
			}
		} catch (error) {
			console.error('切换摄像头失败:', error);
		}
	},
	//切换麦克风（禁用/启用音频流）
	toggleMic(enable) {
		if (!this.livePusher) return;
		try {
			this.livePusher.setAudioMute(!enable);
		} catch (error) {
			console.error('切换麦克风失败:', error);
		}
	},
	//切换镜像
	toggleMirror(enable) {
		if (!this.videoEffectManager || !this.cameraStreamId) {
			console.error('视频效果管理器或流ID不可用');
			return;
		}
		try {
			this.videoEffectManager.setMirror({
				streamId: this.cameraStreamId,
				mirrorType: enable ? 1 : 0  // 1-左右镜像, 0-无镜像
			});
			this.isMirrored = enable;
			console.log('镜像设置成功:', enable ? '开启' : '关闭');
		} catch (error) {
			console.error('切换镜像失败:', error);
		}
	},
	//清理资源
	cleanup() {
		if (this.livePusher) {
			try {
				this.livePusher.stopCamera();
				this.livePusher.stopMicrophone();
				this.livePusher.stopPush();
				this.livePusher.destroy();
				this.livePusher = null;
			} catch (e) {
				console.warn('清理推流失败:', e);
			}
		}
	}
	
  },
  beforeDestroy() {
	window.removeEventListener("resize", this.calculatePlayerSize);
	if (this.livePusher) {
		this.livePusher.stopCamera();
		this.livePusher.stopMicrophone();
		this.livePusher.stopPush();
		this.livePusher.destroy()
		this.livePusher = null
	}
	console.log('停止采集')
  }
};
</script>
<style scoped lang="scss">
	@import "./tengxunyunzb.css";
</style>



// WEBPACK FOOTER //
// tengxunyunzb.vue?1b4780d4